// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__dN0YW"};